import { useState, useEffect } from "react";
const baseUrl = process.env.REACT_APP_API_BASE_URL

export function useNewsDetail(id) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!id) return;

        const controller = new AbortController();

        async function fetchNewsDetail() {
            try {
                setLoading(true);
                setError(null);

                const res = await fetch(`${baseUrl}news/read-published/${id}`, {
                    headers: {
                        Accept: "*/*",
                    },
                    signal: controller.signal,
                });

                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }

                const result = await res.json();
                setData(result);
            } catch (err) {
                if (err.name !== "AbortError") {
                    setError(err.message);
                }
            } finally {
                setLoading(false);
            }
        }

        fetchNewsDetail();

        return () => controller.abort();
    }, [id]);

    return { data, loading, error };
}
